import { NumberItemMutationTypes } from './types';

export const mutations = {
    [NumberItemMutationTypes.SetNumberItemData](state, {data}) {
        return state.number_item_data = data
    },
}